import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as actionsDepartamento from "./_redux/dptoActions";
import * as actionsLocalidad from "../Localidad/_redux/localidadActions";
import Select from 'react-select';

const SelectorDepartamento = (props) => {
    const {setLocalidadesChild, setDepartamentoChild,setLocalidadChild, soloConOfertas}=props;
    const { departamento } = useSelector(
        (state) => ({ departamento: state.departamento }),
        shallowEqual
    );

    const {
        entities:entitiesDepartamentos,
        listLoading:listLoadingDepartamentos,
        error:errorDepartamentos
    } = departamento;

    const { localidad } = useSelector(
        (state) => ({ localidad: state.localidad }),
        shallowEqual
    );

    const {
        entities:entitiesLocalidades,
        listLoading:listLoadingLocalidades,
        error:errorLocalidades
    } = localidad;

    const dispatch = useDispatch();

    useEffect(() => {
        if (!listLoadingDepartamentos && !entitiesDepartamentos && !errorDepartamentos) {
            dispatch(actionsDepartamento.fetchDepartamentos({soloConOfertas}));
        };
        if (!listLoadingLocalidades && !entitiesLocalidades && !errorLocalidades) {
            dispatch(actionsLocalidad.fetchLocalidades({soloConOfertas}));
        };
    }, []);

    return (
        <Select
            //className="form-control"
            classNamePrefix="select"
            //defaultValue={entitiesDepartamentos && entitiesDepartamentos[0]}
            isDisabled={false}
            isLoading={listLoadingDepartamentos}
            isRtl={false}
            isSearchable={true}
            name="color"
            options={entitiesDepartamentos}
            getOptionValue={({ departamentoId }) => departamentoId}
            getOptionLabel={({ departamentoNombre }) => `${departamentoNombre}`}
            placeholder={"Filtrar por Departamento"}
            noOptionsMessage={() => 'Sin Departamentos'}
            onChange={(item)=>{
                setLocalidadesChild(entitiesLocalidades.filter(filtrado=>filtrado.departamentoId===item.departamentoId))
                setLocalidadChild(null);
                setDepartamentoChild(item);
            }}
        />
    )
}

export default SelectorDepartamento;